import React from 'react';
import BadgeHeroSection from './HeroSectionBadge';
import { graphql } from 'gatsby';
const ModularHero = ({ data }) => {
  const {
    heading,
    subheading,
    smallHeading,
    heroImageDesktop,
    heroImageMobile,
    mode,
    layout,
    nobottompadding: noBottomPadding,
    isPostcodeSearch,
    rowReverse,
    textAlignCentre,
  } = data.heroContent[0];

  return (
    <BadgeHeroSection
      heading={heading}
      subHeading={subheading}
      smallHeading={smallHeading.value !== null && smallHeading}
      secondaryHeroImage={heroImageDesktop}
      mode={mode}
      layout={layout}
      rowReverse={rowReverse}
      textAlignCentre={textAlignCentre}
      hidePostcodeSearch={!isPostcodeSearch}
      heroInnerNoPadding={noBottomPadding}
      heroImageMobile={heroImageMobile}
      heroImageDesktop={heroImageDesktop}
    />
  );
};

export default ModularHero;
export const fragment = graphql`
  fragment ModularHero on DatoCmsHero {
    internal {
      type
    }
    heroContent {
      heading {
        value
      }
      smallHeading {
        value
      }
      subheading {
        value
      }
      heroImageMobile {
        gatsbyImageData
      }
      heroImageDesktop {
        gatsbyImageData
      }
      mode
      layout
      nobottompadding
      isPostcodeSearch
      rowReverse
      textAlignCentre
    }
  }
`;
